import React from "react";

export default function noData() {
  return (
    <p
      style={{
        textAlign: "center",
        color: "#8791a0",
        fontSize: "1.5em",
        fontWeight: 300,
        paddingTop: "75px"
      }}
    >
      No data found for this time period.
    </p>
  );
}
